import { LS_KEYS } from "@core/core.constants";
import { ROUTES } from "@router/router.constants";
import { goToRoute } from "@utils/goToRoute";

const KEYS_TO_KEEP_ON_LOGOUT = [
  LS_KEYS.MENU_COLLAPSED,
  LS_KEYS.TENANT,
  LS_KEYS.THEME_NAME,
  LS_KEYS.THEME_VARIANT,
  LS_KEYS.MSW,
];

export const isAuthenticated = () => {
  const token =
    localStorage.getItem(LS_KEYS.ACCESS_TOKEN) ||
    localStorage.getItem(LS_KEYS.REFRESH_TOKEN);
  return Boolean(token);
};

export const onLogout = () => {
  for (const key of Object.values(LS_KEYS)) {
    if (!KEYS_TO_KEEP_ON_LOGOUT.includes(key)) localStorage.removeItem(key);
  }

  goToRoute(ROUTES.LOGIN);
};

export const parseJwt = (token: string) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(""),
  );

  return JSON.parse(jsonPayload);
};
